"use client";

import { Card, CardContent } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function NuestroMenu() {
  const {
    ref: titleRef,
    isVisible: titleVisible
  } = useRevealOnScroll({
    threshold: 0.2
  });
  const dishes = [{
    title: "Sinfonía de Gambas",
    description: "Famoso por su sofisticada combinacion de texturas y sabores, equilibrando lo crujiente con el sabor dulce del marisco. Experiencia cuilinaria delicada y ligera.",
    image: "https://bodegajulian.es/wp-content/uploads/2026/02/PHOTO-2025-07-28-12-58-12-4.jpg?v=g8uxmiqdmb"
  }, {
    title: "Ensalada de ventresca de atún",
    description: "Ensalada de ventresca de atún, servida con tomates y un aderezo casero único. Ingredientes locales que celebran el sabor auténtico de las islas.",
    image: "https://bodegajulian.es/wp-content/uploads/2026/02/PHOTO-2025-07-28-12-58-14-2.jpg?v=9ozevawa1mc"
  }, {
    title: "Solomillo de Cordero",
    description: "Solomillo de cordero cocinado a fuego lento con vino tinto, sobre batatas y con especias aromáticas. Una explosión de sabor que refleja nuestra pasión por la cocina de alma.",
    image: "https://bodegajulian.es/wp-content/uploads/2026/02/PHOTO-2025-07-28-12-59-12-3.jpg?v=9ndsyiewdp"
  }];
  return <section id="nuestro-menú" className="dark bg-background text-foreground py-20 px-4 md:px-8 lg:px-16">
      <div className="mx-auto max-w-7xl">
        <div ref={titleRef} className={`mb-16 text-center transition-all duration-[var(--duration-medium)] ${titleVisible ? "translate-y-0 opacity-100" : "translate-y-10 opacity-0"}`}>
          <h2 className="font-display text-5xl font-bold tracking-tight text-foreground md:text-6xl">
            Nuestro Menú
          </h2>
          <p className="text-muted-foreground mx-auto mt-4 max-w-2xl text-lg">Cada plato elaborado con ingredientes de productores locales, tradición y el corazón de nuestra cocina canaria-española. <br />Conoce tres de nuestros platos mas famosos:</p>
        </div>

        <div className="grid grid-cols-1 gap-8 md:grid-cols-2 lg:grid-cols-3">
          {dishes.map((dish, i) => {
          const {
            ref,
            isVisible
          } = useRevealOnScroll({
            threshold: 0.2
          });
          return <div key={i} data-index={i} ref={ref} className={`transition-all duration-[var(--duration-medium)] ${isVisible ? "translate-y-0 opacity-100" : "translate-y-10 opacity-0"}`} style={{
            transitionDelay: `${i * 100}ms`
          }}>
                <Card className="group relative h-full overflow-hidden rounded-3xl border-0 bg-transparent p-0 shadow-none">
                  <div className="relative aspect-[4/5] w-full overflow-hidden rounded-3xl">
                    <img src={dish.image} alt={dish.title} className="h-full w-full object-cover transition-transform duration-[var(--duration-slow)] ease-[var(--ease-smooth)] group-hover:scale-[1.02]" />
                    <div className="absolute inset-0 bg-gradient-to-b from-transparent via-primary/40 to-primary/80 opacity-0 transition-opacity duration-[var(--duration-medium)] ease-[var(--ease-smooth)] group-hover:opacity-100" />
                    <CardContent className="absolute inset-0 flex flex-col justify-end p-6 opacity-0 transition-opacity duration-[var(--duration-medium)] ease-[var(--ease-smooth)] group-hover:opacity-100">
                      <h3 className="font-display mb-2 text-2xl font-bold text-white md:text-3xl">
                        {dish.title}
                      </h3>
                      <p className="text-sm leading-relaxed text-white/90 md:text-base">
                        {dish.description}
                      </p>
                    </CardContent>
                  </div>
                </Card>
              </div>;
        })}
        </div>
      </div>
    </section>;
}